import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toHours } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';
import MessageForm from './MessageForm';
import MessageContext from './MessageContext';
import RequestedDates from './RequestedDates';

const MessageThread = observer(class MessageThread extends React.Component {
  constructor() {
    super();
    this.getThread = this.getThread.bind(this);
    this.showForm = this.showForm.bind(this);
  }

  componentWillMount() {
    this.state = {
      renderForm: false
    }

    this.getThread();

    // Get current server time
    this.props.store.SessionStore.getCurrentTime(true);
  }

  componentWillUnmount() {
    this.props.store.MessageStore.confirmedDate = this.props.store.MessageStore.threadObject.confirmedDate;
    this.props.store.MessageStore.threadObject = {};
    this.props.store.MessageStore.threadMessages = [];
    this.props.parent.setState({
      messageSid: null
    });
  }

  componentDidUpdate(nextProps) {
    if(nextProps.messageSid !== this.props.messageSid) {
      this.setState({
        renderForm: false
      });

      this.getThread();
    }
  }

  getThread() {
    const { messageSid } = this.props;

    this.props.store.MessageStore.getThreads(true);

    if(messageSid) {
      this.props.store.MessageStore.getThread(messageSid, this.props.preventReload);
    } else {
      this.props.store.MessageStore.getThreadId(this.props.toUserSid, this.props.contextType, this.props.contextId, this.props.sessionRequest, this.props.parent, this.props.preventReload, this.props.proctorLocationSid);
    }

    // Highlight the newly selected thread
    const prevThread = document.querySelector('.thread.active');

    if(prevThread) {
      prevThread.classList.remove('active');
    }

    let thread = null;

    const _this = this;
    const getThread = setInterval(function(){
      thread = document.querySelector(`#thread-${messageSid}`);

      if(thread) {
        thread.className += ' active';
        clearInterval(getThread);
      } else if(!messageSid) {
        clearInterval(getThread);
      }
    }, 100);
  }

  showForm() {
    this.setState({
      renderForm: true
    });
  }

  initials(name, className) {
    const names = name.split(' ');
    const firstInitial = names[0].charAt(0);
    const secondInitial = names[1].charAt(0);

    if(className) {
      return `${firstInitial.toLowerCase()}`
    }

    return firstInitial + secondInitial;
  }

  renderContext() {
    const { translation } = this.props;
    const { threadObject } = this.props.store.MessageStore;
    const { course, exam, examSession } = threadObject;
    const { courseData, userTimezone } = this.props.store.SessionStore;

    let examConfiguration = null;

    if(examSession && examSession.examConfiguration) {
      examConfiguration = examSession.examConfiguration;
    }

    let title = null;
    let subTitle = null;
    let data = [];

    if(examConfiguration && exam) {
      title = exam.title;

      if(threadObject.confirmedDate) {
        data = [
          {
            title: translation.context.exam_date,
            value: `${moment.utc(threadObject.confirmedDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}`
          }, {
            title: translation.context.duration,
            value: toHours(examConfiguration.duration, false, false, false)
          }
        ]
      } else {
        data = [
          {
            title: translation.context.exam_date,
            value: `${moment.utc(examConfiguration.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma')} – ${moment.utc(examConfiguration.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}`
          }, {
            title: translation.context.duration,
            value: toHours(examConfiguration.duration, false, false, false)
          }
        ]
      }
    } else if (threadObject.examSid && exam) {
      title = exam.title;

      data = [
        {
          title: translation.context.exam_date,
          value: `${moment.utc(exam.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma')} – ${moment.utc(exam.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}`
        }, {
          title: translation.context.duration,
          value: toHours(exam.duration, false, false, false)
        }
      ]
    } else if(threadObject.courseSid) {
      title = course.title;

      data = [
        {
          title: translation.context.course_code,
          value: course.code
        }, {
          title: translation.context.instructor,
          value: `${courseData.instructor.firstName} ${courseData.instructor.lastName}`
        }
      ]
    }

    // Add proctor context if it’s a with a proctor
    if(threadObject.proctorAccountUserSid && threadObject.proctorAccountLocation) {
      const { proctor } = this.props.store.ProctorStore;
      const location = threadObject.proctorAccountLocation;
      let address = location.address1;

      if(location.address2) {
        address += `, ${location.address2}`
      }

      subTitle = translation.context.proctor;

      const proctorData = [
        {
          title: translation.context.proctor,
          value: `${proctor.accountName}`
        },
        {
          title: translation.context.location,
          value: `${address}, ${location.place}, ${location.region} ${location.postalCode} ${location.country}`
        }
      ];

      data = data.concat(proctorData);
    }

    if(title) {
      return (
        <MessageContext
          title={title}
          subTitle={subTitle}
          data={data}
          {...this.props}
        />
      );
    }

    return '';
  }

  render() {
    const { translation } = this.props;
    const { MessageStore, SessionStore } = this.props.store;
    const { threadMessages, threadObject } = MessageStore;
    const { userTimezone } = this.props.store.SessionStore;
    let sessionRequest = false;

    if(threadObject.dateOption1 || (threadObject.proctorAccountLocationSid && threadObject.initiatingUserSid)) {
      sessionRequest = true;
    }

    if(!SessionStore.loading) {
      if(threadMessages.length > 0) {
        return (
          <article className="inbox__thread">
            {this.props.drawer &&
              <header className="drawer__header">
                <div className="wrap">
                  {/* <h4 className="inbox__thread-title">{activeMessage.subject}</h4> */}
                  <h1 className="drawer__title">{translation.message}</h1>

                  <ul className="inbox__tools">
                    <li>
                      <button onClick={this.showForm}>
                        <icons.iconReply />
                        {translation.reply}
                      </button>
                    </li>
                    {/* <li>
                      <button>
                        <icons.iconArchive />
                        {translation.archive}
                      </button>
                    </li> */}
                  </ul>
                </div>
              </header>
            }

            {!this.props.drawer &&
              <header className="inbox__thread-header">
                {/* <h4 className="inbox__thread-title">{activeMessage.subject}</h4> */}
                <h5 className="inbox__thread-title">{translation.message}</h5>

                <ul className="inbox__tools">
                  <li>
                    <button onClick={this.showForm}>
                      <icons.iconReply />
                      {translation.reply}
                    </button>
                  </li>
                  {/* <li>
                    <button>
                      <icons.iconArchive />
                      {translation.archive}
                    </button>
                  </li> */}
                </ul>
              </header>
            }

            <div className="inbox__thread-body">
              {this.renderContext()}

              <ol className="conversation">
                {threadMessages.map(
                  (message, i) => {
                    let fromUser = null;

                    if(message.fromUser) {
                      fromUser = message.fromUser;
                    } else {
                      fromUser = message.fromProctorAccountUser;
                    }

                    return (
                      <li key={i}>
                        <blockquote className={`conversation__message ${fromUser.sid === SessionStore.userData.userSid ? 'sent' : 'received'}`}>
                          <div className="conversation__body">
                            <div className="conversation__content">
                              <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(message.content.replace(/\r?\n|\r/g, ' '))}}></div>
                            </div>
                            <time className="conversation__timestamp">{moment.utc(message.createdDate).tz(userTimezone).format('M/D/YYYY h:mma')}</time>
                          </div>

                          <cite className="conversation__author conversation__author--sm">
                            <abbr
                              className={`
                                avatar--initials conversation__avatar ${this.initials(fromUser.firstName + ' ' + fromUser.lastName, true)}
                              `}
                              title={`${fromUser.firstName} ${fromUser.lastName}`}>
                              {fromUser.firstName.charAt(0)}{fromUser.lastName.charAt(0)}
                            </abbr>
                          </cite>
                        </blockquote>
                      </li>
                    )
                  }
                )}
              </ol>

              {(threadObject.dateOption1 || threadObject.confirmedDate) &&
                <RequestedDates
                  {...this.props}
                />
              }

              <MessageForm
                sessionRequest={sessionRequest}
                renderForm={this.state.renderForm}
                showForm={this.showForm}
                mode={'reply'}
                threadSid={threadMessages[0].messageThreadSid}
                threadObject={threadObject}
                messageCount={threadMessages.length}
                confirmedDate={threadObject.confirmedDate}
                confirmedDateExpiration={threadObject.confirmedDateExpiration}
                parentThread={this}
                examConfiguration={threadObject.examConfiguration}
                examSession={threadObject.examSession}
                {...this.props}
              />
            </div>
          </article>
        )
      } else if(this.props.drawer) {
        return (
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.new_message}</h1>
              </div>
            </header>

            <div className="wrap block-form">
              <MessageForm
                sessionRequest={this.props.sessionRequest}
                renderForm={true}
                showForm={this.showForm}
                mode={'create'}
                parentThread={this}
                messageCount={threadMessages.length}
                threadObject={threadObject}
                {...this.props}
              />
            </div>
          </div>
        )
      }
    }

    return null;
  }
})

export default translate('MessageThread')(MessageThread);



// WEBPACK FOOTER //
// ./src/app/components/Messages/MessageThread.js